import axios from '../utils/axios';

export const getProjectsOverview = () => {
  return axios.get('projects/overview').then(response => response.data);
}

export const getProjectDetail = id => {
  return axios.get(`projects/${id}/detail`).then(response => response.data);
}

export const getProjectThumbnail = id => {
  return axios.get(`projects/detail/multimedia/${id}/thumbnail`, { responseType: 'blob' }).then(response => response.data);
}

export const getProjectMultimedia = id => {
  return axios.get(`projects/detail/multimedia/${id}/result`, { responseType: 'blob' }).then(response => response.data);
}
export const getVideoUrl = id => {
  return axios.get(`projects/detail/video/${id}/url`).then(response => response.data);
}

export const getGeoServerKey = () => {
  return axios.get('services/geoserverKey').then(response => response.data);
}